import { useQuery } from '@tanstack/react-query';
import { get } from 'api/base';
import type { PreventionAlert } from 'types/preventionAlerts';

type PreventionAlertsResponse = {
  alerts: PreventionAlert[];
};

export const preventionAlertKeys = {
  all: (medatixxId?: string | null) => ['preventionAlerts', medatixxId] as const,
  forInteraction: (medatixxId?: string | null, interactionId?: string) =>
    ['preventionAlerts', medatixxId, interactionId ?? null] as const,
};

export function usePreventionAlerts(medatixxId?: string | null, interactionId?: string) {
  return useQuery<PreventionAlertsResponse>({
    queryKey: preventionAlertKeys.forInteraction(medatixxId, interactionId),
    queryFn: () =>
      get('preventionAlerts', undefined, {
        medatixxId,
        ...(interactionId ? { interactionId } : {}),
      }) as Promise<PreventionAlertsResponse>,
    enabled: !!medatixxId,
    refetchInterval: 1000 * 3,
    // The key changes when the recording starts; keep the section on screen until the answer is
    // in, but never show one patient's alerts while another one loads.
    placeholderData: (previous, previousQuery) =>
      previousQuery?.queryKey[1] === medatixxId ? previous : undefined,
  });
}
